import { ForgetPasswordPageContent } from "@app/auth/pages";
import { reverseGuardedRoutes } from "@framework/middleware";
import { pageHead } from "@framework/config/drivers";
import { trans } from "@mongez/localization";

export const loader = reverseGuardedRoutes();

export default function ForgotPassword() {
  return <ForgetPasswordPageContent />;
}

export function meta() {
  return pageHead({
    title: trans("auth.forgotPassword"),
  });
}
